import { PRODUCT_TYPE_IDS } from "@chef/constants";
import { useAppDispatch } from "@chef/state-management/hooks";
import { setPresetDeviation } from "@chef/state-management";
import { isEmptyArray } from "@chef/utils/array";

import { CTAComponent, CTAComponentValueProps } from "./CTA";

interface IPresetItemButton {
  week: number;
  year: number;
  presetItemIds: {
    groceryIds: {
      week: number;
      year: number;
      _type: "specificGroceries";
      groceries: string[];
    };
    recipeIds: {
      week: number;
      year: number;
      _type: "specificRecipes";
      recipes: string[];
    };
  };
  cta: CTAComponentValueProps;
}

interface PresetItemButtonProps {
  value?: IPresetItemButton;
}

export const PresetItemButtonComponent = ({ value }: PresetItemButtonProps) => {
  if (!value) {
    return;
  }

  const { week, year, cta, presetItemIds } = value;

  if (!presetItemIds) {
    return;
  }

  const presetRecipes = presetItemIds.recipeIds.recipes;
  const presetGroceries = presetItemIds.groceryIds.groceries;

  const recipes = presetRecipes.map((recipeId) => ({
    productId: recipeId,
    productTypeId: PRODUCT_TYPE_IDS.PICKANDMIX,
  }));

  const groceries = presetGroceries.map((groceryId) => ({
    variationId: groceryId,
    productTypeId: PRODUCT_TYPE_IDS.STANDALONE,
    quantity: 1,
  }));

  const dispatch = useAppDispatch();

  if (isEmptyArray(presetRecipes)) {
    return null;
  }

  const onAddPresetItemsToDeviationBasket = () => {
    // Update the preselected recipes and groceries
    dispatch(
      setPresetDeviation({
        week,
        year,
        products: [...recipes, ...groceries],
      }),
    );
  };

  return (
    <CTAComponent value={cta} onClick={onAddPresetItemsToDeviationBasket} />
  );
};
